class Accordion {
    constructor(topRow, bottomRow, bottomRowWrapper, scrollDown) {
        this.topRow = topRow;
        this.bottomRow = bottomRow;
        this.bottomRowWrapper = bottomRowWrapper;
        this.scrollDown = scrollDown;
    }
    scrollDownPage(setHeight) {
        let scrollHeight = setHeight;
        const currentScroll = window.pageYOffset;
        const windowHeight = window.innerHeight;
        if (scrollHeight > windowHeight) {
            scrollHeight = windowHeight;
        }
        const distanceToScroll = scrollHeight + currentScroll;
        const startTime = new Date().getTime();
        if (currentScroll < distanceToScroll) {
            if (distanceToScroll > currentScroll) {
                requestAnimationFrame(scroll);
            }

            function scroll() {
                const duration = 300;
                const now = new Date().getTime();
                const time = Math.min(1, (now - startTime) / duration);
                window.scroll(
                    0,
                    Math.ceil(
                        time * (distanceToScroll - currentScroll) +
                        currentScroll
                    )
                );

                if (window.pageYOffset < distanceToScroll) {
                    requestAnimationFrame(scroll);
                }
            }
        }
    }
    toggleAccordion(e) {
        const topRow = e.currentTarget;
        const bottomRow = topRow.parentNode.querySelector(this.bottomRow);
        const bottomRowWrap = bottomRow.querySelector(this.bottomRowWrapper);
        const height = bottomRowWrap.offsetHeight;
        const topRowHeight = topRow.offsetHeight;
        let setHeight = null;

        if (!bottomRow.classList.contains("is-active")) {
            bottomRow.classList.add("is-active");
            e.currentTarget.classList.add("is-active");
            setHeight = height;
        } else {
            bottomRow.classList.remove("is-active");
            e.currentTarget.classList.remove("is-active");
            setHeight = 0;
        }
        bottomRow.style.height = setHeight + "px";

        if (this.scrollDown) {
            this.scrollDownPage(setHeight);
        }
    }
    setHeight() {
        let bottomRow = document.querySelectorAll(this.bottomRow);
        if (bottomRow) {
            bottomRow = Array.prototype.slice.call(bottomRow);
            bottomRow.forEach(element => {
                const bottowRowWrap = element.querySelector(
                    this.bottomRowWrapper
                );

                if (element.classList.contains("is-active")) {
                    const heightToSet = bottowRowWrap.offsetHeight;
                    element.style.height = heightToSet + "px";
                }
            });
        }
    }
    init() {
        let topRows = document.querySelectorAll(this.topRow);

        if (topRows) {
            topRows = Array.prototype.slice.call(topRows);
            topRows.forEach(topRow => {
                const rowWrapper = topRow.parentNode;
                const bottomRow = rowWrapper.querySelector(this.bottomRow);
                topRow.addEventListener("click", e => {
                    this.toggleAccordion(e, bottomRow);
                });
            });
        }
    }
}

const footerAccordion = new Accordion(
    ".top-row",
    ".bottom-row",
    ".bottom-row-wrapper",
    true
);
const sectionAccordion = new Accordion(
    ".accordion-wrap .accordion-title",
    ".accordion-content",
    ".content-wrap",
    false
);

export default footerAccordion;
export { sectionAccordion };
